import { TextCell } from "@similarweb/pro-logic-components";

import type { PrimitiveListCellValue } from "app/pages/sales-intelligence/common-components/table-cells";
import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";

import { createPrimitiveListCellValue } from "../../utils";
import CheckMarkCell from "../CheckMarkCell/CheckMarkCell";
import ListCell from "../ListCell/ListCell";

import { DATA_AUTOMATION_VALUE } from "./const";

type Props = {
    value: boolean | string | readonly string[];
    formatArrayValue: (value: readonly PrimitiveListCellValue[]) => string | number;
};

const TechnologiesCell = ({ value, formatArrayValue }: Props) => {
    if (typeof value === "boolean") {
        return (
            <CheckMarkCell
                dataAutomation={DATA_AUTOMATION_VALUE}
                isChecked={value}
                falseValue={NO_DATA_HYPHEN}
            />
        );
    }

    if (typeof value === "string") {
        return <TextCell dataAutomation={DATA_AUTOMATION_VALUE}>{value}</TextCell>;
    }

    if (Array.isArray(value)) {
        const content = createPrimitiveListCellValue({
            value,
            formatValue: formatArrayValue,
        });

        return (
            <ListCell
                dataAutomation={DATA_AUTOMATION_VALUE}
                value={value}
            >
                {content}
            </ListCell>
        );
    }

    return null;
};

export default TechnologiesCell;
